import { useEffect } from 'react';
import { useMutation } from '@apollo/client';
import { usePlatformSource } from '@/hooks/usePlatformSource';
import { CREATE_COLLECTION_STAT } from '@/features/BookmarkCollections/api';

export function useCollectionStat(collectionId: string) {
  const source = usePlatformSource();

  const [createCollectionStat] = useMutation(CREATE_COLLECTION_STAT, {
    errorPolicy: 'ignore',
  });

  useEffect(() => {
    if (!collectionId) return;

    createCollectionStat({
      variables: { bookmarkCollectionId: collectionId, source },
    }).catch(() => undefined);
  }, [collectionId, source, createCollectionStat]);
}
